const Error = () => {
    return (
        <div className='page-body' style={{textAlign: 'center'}}>
            <h1>Error: Page Not Found</h1>
        </div>
    );
}

export default Error;